<template>
  <ul class="category-list">
    <li
      v-for="category in categories"
      :key="category.id"
      class="-option"
      :class="{ '-suggested': category.label === suggestedCategoryLabel }"
    >
      <span class="label" @click="categoryClick(category)">
        {{ category.label }}
        <small v-if="category.id === currentTeam.fallback_category_id">(Fallback category)</small>
        <span v-if="!category.children" class="count">{{ category.categorized_messages_count }}</span>
      </span>

      <CategoryList
        v-if="category.children"
        :categories="category.children"
        :suggested-category-label="suggestedCategoryLabel"
        @categoryClicked="categoryClick"
      >
      </CategoryList>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from "vuex";

import CategoryList from "@/components/categoryList";

export default {
  name: "CategoryList",

  components: {
    CategoryList
  },

  props: {
    categories: {
      type: Array,
      require: true,
      default: () => {
        return [];
      }
    },
    suggestedCategoryLabel: {
      type: String,
      require: false,
      default: ""
    }
  },

  computed: {
    ...mapGetters(["currentTeam"])
  },

  methods: {
    categoryClick(category) {
      this.$emit("categoryClicked", category);
    }
  }
};
</script>
